import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import WidthContainer from '../../../WidthContainer';
import { BodyLarge, Heading1Text, TitleLarge } from '../../../Texts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 200px;
  padding-bottom: 200px;
  gap: 30px;
`;

const ContainerBackground = styled.div`
  background-color: ${({ theme }) => theme.background.light};
  position: absolute;
  width: 100%;
  left: 0px;
`;

const StyledTitleLarge = styled(TitleLarge)`
  font-weight: 600;
`;

const RowContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
  }
`;

const Item = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.background.secondary};
  height: 200px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 20px;
`;

const PartnerAndRevenueCosts = () => {
  const backgroundRef = useRef(null);
  const [siblingHeight, setSiblingHeight] = useState<number>(0);

  useEffect(() => {
    const updateHeight = () => {
      const node = backgroundRef.current as HTMLElement | null;
      if (node) {
        setSiblingHeight(node.offsetHeight);
      }
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);

    if (backgroundRef.current) {
      observer.observe(backgroundRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <ContainerBackground ref={backgroundRef}>
        <WidthContainer>
          <Container>
            <Heading1Text>Partner Revenue & Costs</Heading1Text>
            <RowContainer>
              <Item>
                <StyledTitleLarge>Token List & Setup</StyledTitleLarge>
                <BodyLarge>$0 for the first 25 projects</BodyLarge>
              </Item>
              <Item>
                <StyledTitleLarge>Platform Fees</StyledTitleLarge>
                <BodyLarge>
                  Platform fees are 1.5% per swap and 3.5% per gift card.
                </BodyLarge>
              </Item>
              <Item>
                <StyledTitleLarge>Revenue Share</StyledTitleLarge>
                <BodyLarge>
                  You receive up to 20% of those fees from your token—forever
                </BodyLarge>
              </Item>
            </RowContainer>
          </Container>
        </WidthContainer>
      </ContainerBackground>
      <div style={{ height: siblingHeight }} />
    </>
  );
};

export default PartnerAndRevenueCosts;
